import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./tableInfo.scss";
// owl carasoul work end
import { Skeleton } from "@material-ui/lab";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { RootState } from "../../store/reducers";
import { convertTo12HourFormat } from "../../utils/genral-functions";
import nestclock from "../../assets/images/nestclock.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { get_lang } from "../../helper/getLang";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";

const TableInfo = () => {
  const state = useSelector((state: RootState) => state.appReducer);
  const { bookingForm, langValue, redirectCheckout } = state;
    const dispatch = useDispatch();
    const {setRedirectCheckout} = bindActionCreators(actionCreators, dispatch)
  const { t } = useTranslation();   
  const { bookingTime, NoGuest, bookingDate } = bookingForm || {};
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams: any = new URLSearchParams(search);
  const [bId] = useState(searchParams.get("bId"));
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [appState, setappState] = useState({ langValue: "en" });
  const [category, setcategory] = useState({
    branch_name: { en: "10:00 - 13:00" },
    tag: [],
    storeInfo: { logo: null, name: "Food & Drink Event" },
  });

  useEffect(() => {
    if (!redirectCheckout && (bookingForm == undefined || bookingForm == null)) {
      navigate(`/${slug}/step-1?bId=${bId}`);
    }
  }, [bookingForm]);

  useEffect(() => {
    setRedirectCheckout(false)
  }, [])
  
  return (
    <div>
      {(isLoading || redirectCheckout) ? (
        <React.Fragment>
          <div className="kanwar row m-0 mb-4 mt-3 d-flex flex-row">
            <div className="col-6  ">
              <Skeleton height={50} />
            </div>
            <div className="col-10 ">
              <Skeleton height={50} />
            </div>
            <div className="col-3 ">
              <Skeleton height={50} />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          id="TableInfoMain"
          className={`px-2  ${
            appState?.langValue === "ar"
              ? `directionRt classForArabicReOrderMain`
              : ""
          } ${appState?.langValue == "ar" ? "arabicFamilyParent" : " "}`}
        >
          <div
            className={`row mb-3   ${
              appState?.langValue === "ar" ? "pr-2 pl-3" : "pr-3 pl-2"
            } `}
          >
            <div className={`owl_item black col-12 px-0`}>
              <a className="cursor-pointer">
                <span className="card-item">
                  <section id={`Products`}>
                    <div id={`category_`} className="w-100">
                      <div className={`inner_prod`}>
                        <span>
                          <div className="prdCard px-3 d-flex flex-column justify-content-end">
                            <div
                              className={`my-3  d-flex justify-content-between  ${
                                appState?.langValue === "ar"
                                  ? `storeNameArabic`
                                  : `storeName`
                              } `}
                            >
                              <span
                                className={`d-flex align-items-center ${
                                  state.langValue === "ar"
                                    ? `direction-ltr`
                                    : ""
                                }`}
                              >
                                <CalendarMonthIcon />
                                <h1
                                  className={`reOrderheading primary-text familysora700   textOver  px-2 m-0  ${
                                    appState?.langValue === "ar"
                                      ? "text-right"
                                      : "text-left"
                                  }`}
                                >
                                  {" "}
                                  {`${
                                    bookingDate != null
                                      ? bookingDate
                                      : "Not Available"
                                  }`}{" "}
                                </h1>
                              </span>
                              <span
                                className={`d-flex align-items-center ${
                                  state.langValue === "ar"
                                    ? `direction-ltr`
                                    : ""
                                }`}
                              >
                                <img src={nestclock} alt="nestclock" />

                                <h1
                                  className={`reOrderheading primary-text familysora700   textOver  px-2 m-0  ${
                                    appState?.langValue === "ar"
                                      ? "text-right"
                                      : "text-left"
                                  }`}
                                >
                                  {`${
                                    bookingTime != null
                                      ? convertTo12HourFormat(
                                          bookingTime?.starting
                                        )
                                      : "Not Available"
                                  }`}{" "}
                                </h1>
                              </span>
                            </div>
                            {/* <hr/> */}
                            <div
                              className={`my-3  guest  ${
                                appState?.langValue === "ar" ? `` : ``
                              } `}
                            >
                              <h3
                                className={`reOrderheading textOver familysora400 px-2 m-0 ${
                                  appState?.langValue === "ar"
                                    ? "text-right"
                                    : "text-left"
                                }`}
                              >
                                {bookingForm?.slotsType == 1
                                  ? `${NoGuest} ${t("custom-msg.guest")}`
                                  : bookingForm?.slotsType == 2
                                  ? get_lang(
                                      bookingForm?.packageName,
                                      langValue
                                    )
                                  : "Not Available"}
                              </h3>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </section>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default withTranslation()(TableInfo);
